import forEach from 'lodash/forEach';
import Constants from './Constants';

const giftCardValidation = (giftcard, enableV2GiftCardForm = false) => {
    if (!giftcard) {
        return {
            giftCardNumError: enableV2GiftCardForm ? Constants.CARD_ERROR_V2 : Constants.CARD_ERROR,
        };
    }
    const isValid = enableV2GiftCardForm
        ? giftcard.length === 16 || giftcard.length === 19
        : giftcard.length === 19;
    if (!isValid) {
        return {
            giftCardNumError: enableV2GiftCardForm ? Constants.CARD_ERROR_V2 : Constants.CARD_ERROR,
        };
    }
    return { giftCardNumError: Constants.BLANK };
};

const giftCardPinValidation = (pin, enableV2GiftCardForm = false) => {
    if (!pin) {
        return {
            giftCardPinError: enableV2GiftCardForm ? Constants.PIN_ERROR_V2 : Constants.PIN_ERROR,
        };
    }
    const isValid = enableV2GiftCardForm ? pin.length === 4 || pin.length === 8 : pin.length === 4;
    if (!isValid) {
        return {
            giftCardPinError: enableV2GiftCardForm ? Constants.PIN_ERROR_V2 : Constants.PIN_ERROR,
        };
    }
    return { giftCardPinError: Constants.BLANK };
};

const dynamicSchema = {
    giftCardNum: giftCardValidation,
    giftCardPin: giftCardPinValidation,
};

export function runSingleValidator(fieldName, data, featureFlags = {}) {
    const { enableV2GiftCardForm = false } = featureFlags;
    let result = {};
    if (dynamicSchema[fieldName] !== undefined) {
        result = dynamicSchema[fieldName](data[fieldName], enableV2GiftCardForm);
    }
    return result;
}

export function runValidator(data, featureFlags = {}) {
    const { enableV2GiftCardForm = false } = featureFlags;
    const result = {};
    forEach(Object.keys(dynamicSchema), (validator) => {
        Object.assign(result, dynamicSchema[validator](data[validator], enableV2GiftCardForm));
    });
    return result;
}
